/**
 * Shared inline style for the hero background image — consistent across pages.
 */
export const heroBgStyle = {
  backgroundImage:
    "linear-gradient(180deg, rgba(10,15,44,0.82) 0%, rgba(10,15,44,0.94) 100%), url('/bg-tech.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};
